import Swiper from 'swiper';
import 'swiper/css';
export function reInitializeSwiper(SwiperElement, options) {
    if (SwiperElement.dataset.reInitialized)
        return SwiperElement.swiper;
    SwiperElement.swiper?.destroy();
    const swiper = new Swiper(SwiperElement, options);
    SwiperElement.dataset.reInitialized = 'true';
    return swiper;
}
